/**
 * @desc 获取报警规则列表
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.AlertRuleIotRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.IotAlertRuleResult>>> {
  return defHttp.post({
    url: '/web/alert/rule/listAlertRule',
    data,
  });
}

export function mock(
  data: defs.AlertRuleIotRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.IotAlertRuleResult>>> {
  return defHttp.post({
    url: '/mock/web/alert/rule/listAlertRule',
    data,
  });
}
